import type { AppSettingsDto, BoolSettingDto, SliderSettingDto } from '@sancare-commons/settings/dto/settings'
import type { AppFlatSetting, SancareFlatSettings } from '@sancare-commons/settings/types'

function mapSliderSetting(setting: SliderSettingDto): number {
  return setting.values[setting.index ?? setting.default] ?? setting.values[setting.default]
}

function mapBoolSetting(setting: BoolSettingDto): boolean {
  return setting.value ?? setting.default
}

export function mapFlatAppSettings(rawSettings: AppSettingsDto): AppFlatSetting {
  const flatAppSettings = {}
  if (rawSettings.sliderSettings) {
    for (const [name, setting] of Object.entries(rawSettings.sliderSettings)) {
      flatAppSettings[name] = mapSliderSetting(setting)
    }
  }
  if (rawSettings.boolSettings) {
    for (const [name, setting] of Object.entries(rawSettings.boolSettings)) {
      flatAppSettings[name] = mapBoolSetting(setting)
    }
  }
  return flatAppSettings
}

export function mapFlatSancareSettings(rawSettings: AppSettingsDto): SancareFlatSettings {
  const flatAppSettings: SancareFlatSettings = mapFlatAppSettings(rawSettings)
  if (rawSettings.arraySettings) {
    for (const [name, setting] of Object.entries(rawSettings.arraySettings)) {
      flatAppSettings[name] = setting
    }
  }
  return flatAppSettings
}
